module.exports = __webpack_public_path__ + "static/media/promo.46a6c595.png";